module.exports = __webpack_public_path__ + "static/media/slackEmoji2.53820283.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji2.gif
// module id = 36
// module chunks = 0